import type { PropsWithChildren } from "react"
import { usePage } from "@inertiajs/react"

import { AppContent } from "@/components/app-content"
import { AppShell } from "@/components/app-shell"
import { AppSidebar } from "@/components/app-sidebar"
import { AppSidebarHeader } from "@/components/app-sidebar-header"
import { LanguageDetectionModal } from "@/components/language-detection-modal"
import type { BreadcrumbItem } from "@/types"

export default function AppSidebarLayout({
  children,
  breadcrumbs = [],
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  const { props } = usePage()
  const userLanguage = (props.auth as any)?.user?.language || null

  return (
    <AppShell variant="sidebar">
      <AppSidebar />
      <AppContent variant="sidebar" className="overflow-x-hidden">
        <AppSidebarHeader breadcrumbs={breadcrumbs} />
        {children}
      </AppContent>
      <LanguageDetectionModal userLanguage={userLanguage} />
    </AppShell>
  )
}
